import styled, { css } from "styled-components";
import { Theme } from "@tvg/design-system";

export const IconWrapper = styled.button`
  height: 20px;
  margin-right: ${({ theme }) => theme.space["space-3"]};
  pointer-events: none;
`;

// TODO: this is the default styles file minified, it's a workaround. We are currently exploring options with our css webpack plugin.
// Whenever you are changing or bumping react-day-picker, please make sure to update this string as well.
export const MinifiedDayPickerDefaultStyles =
  ".DayPicker{display:inline-block;font-size:1rem}.DayPicker-wrapper{position:relative;flex-direction:row;padding-bottom:1em;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.DayPicker-Months{display:flex;flex-wrap:wrap;justify-content:center}.DayPicker-Month{display:table;margin:0 1em;margin-top:1em;border-spacing:0;border-collapse:collapse;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.DayPicker-NavButton{position:absolute;top:1em;right:1.5em;left:auto;display:inline-block;margin-top:2px;width:1.25em;height:1.25em;background-position:center;background-size:50%;background-repeat:no-repeat;color:#8b9898;cursor:pointer}.DayPicker-NavButton:hover{opacity:.8}.DayPicker-NavButton--prev{margin-right:1.5em;background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAVVJREFUWAnN2G0KgjAYwPHpGfRkaZeqvgQaK+hY3SUHrk1YzNLay/OiEFp92I+/Mp2F2Mh2lLISWnflFjzH263RQjzMZ19wgs73ez0o1WmtW+dgA01VxrE3p6l2GLsnBy1VYQOtVSEH/atCCgqpQgKKqYIOiq2CBkqtggLKqQIKgqgCBjpJ2Y5CdJ+zrT9A7HHSTA1dxUdHgzCqJIEwq0SDsKsEg6iqBIEoq/wEcVRZBXFV+QJxV5mBtlDFB5VjYTaGZ2sf4R9PM7U9ZU+lLuaetPP/5Die3ToO1+u+MKtHs06qODB2zBnI/jBd4MPQm1VkY79Tb18gB+C62FdBFsZR6yeIo1YQiLJWMIiqVjQIu1YSCLNWFgijVjYIuhYYCKoWKAiiFgoopxYaKLUWOii2FgkophYp6F3r42W5A9s9OcgNvva8xQaysKXlFytoqdYmQH6tF3toSUo0INq9AAAAAElFTkSuQmCC')}.DayPicker-NavButton--next{background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAXRJREFUWAnN119ugjAcwPHWzJ1gnmxzB/BBE0n24m4xfNkTaOL7wOtsl3AXMMb+Vjaa1BG00N8fSEibPpAP3xAKKs2yjzTPH9RAjhEo9WzPr/Vm8zgE0+gXATAxxuxtqeJ9t5tIwv5AtQAApsfT6TPdbp+kUBcgVwvO51KqVhMkXKsVJFXrOkigVhCIs1Y4iKlWZxB1rX4gwlpRIIpa8SDkWmggrFq4IIRaJKCYWnSgnrXIQV1r8YD+1Vrn+bReagysIFfLABRt31v8oBu1xEBttfRbltmfjgEcWh9snUS2kNdBK6WN1vrOWxObWsz+fjxevsxmB1GQDfINWiev83nhaoiB/CoOU438oPrhXS0WpQ9xc1ZQWxWHqUYe0I0qrKCQKjygDlXIQV2r0IF6ViEBxVTBBSFUQQNhVYkHIVeJAtkNsbQ7c1LtzP6FsObhb2rCKv7NBIGoq4SDmKoEgTirXAcJVGkFSVVpgoSrXICGUMUH/QBZNSUy5XWUhwAAAABJRU5ErkJggg==')}.DayPicker-NavButton--interactionDisabled{display:none}.DayPicker-Caption{display:table-caption;margin-bottom:.5em;padding:0 .5em;text-align:left}.DayPicker-Caption>div{font-weight:500;font-size:1.15em}.DayPicker-Weekdays{display:table-header-group;margin-top:1em}.DayPicker-WeekdaysRow{display:table-row}.DayPicker-Weekday{display:table-cell;padding:.5em;color:#8b9898;text-align:center;font-size:.875em}.DayPicker-Weekday abbr[title]{border-bottom:none;text-decoration:none}.DayPicker-Body{display:table-row-group}.DayPicker-Week{display:table-row}.DayPicker-Day{display:table-cell;padding:.5em;border-radius:50%;vertical-align:middle;text-align:center;cursor:pointer}.DayPicker-WeekNumber{display:table-cell;padding:.5em;min-width:1em;border-right:1px solid #eaecec;color:#8b9898;vertical-align:middle;text-align:right;font-size:.75em;cursor:pointer}.DayPicker--interactionDisabled .DayPicker-Day{cursor:default}.DayPicker-Footer{padding-top:.5em}.DayPicker-TodayButton{border:none;background-color:transparent;background-image:none;box-shadow:none;color:#4a90e2;font-size:.875em;cursor:pointer}.DayPicker-Day--today{color:#d0021b;font-weight:700}.DayPicker-Day--outside{color:#8b9898;cursor:default}.DayPicker-Day--disabled{color:#dce0e0;cursor:default}.DayPicker-Day--sunday{background-color:#f7f8f8}.DayPicker-Day--sunday:not(.DayPicker-Day--today){color:#dce0e0}.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside){position:relative;background-color:#4a90e2;color:#f0f8ff}.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover{background-color:#51a0fa}.DayPicker:not(.DayPicker--interactionDisabled) .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover{background-color:#f0f8ff}.DayPickerInput{display:inline-block}.DayPickerInput-OverlayWrapper{position:relative}.DayPickerInput-Overlay{position:absolute;left:0;z-index:1;background:#fff;box-shadow:0 2px 5px rgba(0,0,0,.15)}";

export const DayPickerCustomStyles = (
  theme: Theme,
  options: { inputOverlayAlignment: string }
) => `
    ${MinifiedDayPickerDefaultStyles}
    .DayPickerInput {
      width: 250px;
    }
    .DayPicker {
      font-family: ${theme.fonts.regular};
      font-size: ${theme.fontSizes.s};
      color: ${theme.colorTokens.content.default};
      border: 1px solid ${theme.colorTokens.border.default};
      border-radius: 4px; 
      box-shadow: ${theme.elevations.low};
    }
    .DayPickerInput-Overlay {
      margin-top: ${theme.space["space-3"]};
      ${
        options.inputOverlayAlignment === "right"
          ? css`
              right: 0;
              left: auto;
            `
          : css`
              right: auto;
              left: 0;
            `
      }
    }
    .DayPicker-wrapper {
      padding: 0;
      width: 325px;
    }
    .DayPicker-Caption {
      font-size: ${theme.fontSizes.s};
      padding-left: ${theme.space["space-5"]};
      margin: 0 0 ${theme.space["space-7"]} 0;
    }
    .DayPicker-Month {
      margin: ${theme.space["space-5"]};
      border-collapse: separate;
      border-spacing: ${theme.space["space-3"]};
    }
    .DayPicker-NavBar {
      position: absolute;
      right: 12px;
      top: 0;
    }
    .DayPicker-Weekday {
      font-family: ${theme.fonts.bold};
      font-size: ${theme.fontSizes.s};
      color: ${theme.colorTokens.content.strong}; 
      padding: 0;
    }
    .DayPicker-Day {
      padding: 0;
      font-size: ${theme.fontSizes.s};
      width: 32px;
      height: 32px;
    }
    .DayPicker-Day--today:not(.DayPicker-Day--outside) {
      display: flex;
      justify-content: center;
      align-items: center;  
      font-weight: ${theme.fontWeights.normal};
      color: ${theme.colorTokens.content.default}; 
      border-radius: 50%;
      border: 1px solid ${theme.colorTokens.component.input.active};
      background: transparent;
    } 
    .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
      background-color: ${theme.colorTokens.component.input.selected};
    }
    .DayPicker-Day--disabled{
      color: ${theme.colorTokens.content.disabled}; 
      pointer-events: none;
    }
    .DayPicker:not(.DayPicker--interactionDisabled) .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
      background-color: ${theme.colorTokens.component.input.hover}; 
    }
    .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
      background-color: ${theme.colorTokens.component.input.selected};
    }
    .DayPicker-NavBar {
      top: 24px;
      right: 24px;
    }
`;

export const DatePickerWrapper = styled.div`
  position: absolute;
  background: ${({ theme }) => theme.colorTokens.background.surface};
  box-shadow: ${({ theme }) => theme.elevations.low};
  border-radius: 4px;
  min-height: 322px;
  z-index: 1;
`;

export const InputRangeWrapper = styled.div`
  display: flex;

  & > div {
    margin-right: ${({ theme }) => theme.space["space-5"]};
  }
`;
